/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-23 15:03:32
 * @LastEditors: K
 * @LastEditTime: 2022-09-08 16:25:39
 */
import React, { ReactElement, useEffect, useState } from 'react';
import { EditableList } from '../../../compnents/list/EditableList';
import styles from '../monitoringTab.module.css'
import { UseQuery } from './useQuery';
import { UseColumns } from "./useColumns";
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { getUseDetail, getUseDetailExport, getUseDetailFive } from '../monitoringPageSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { Modal, notification, Table } from 'antd';

interface UseDetailPageProps {
  state: string
}

export const UseDetailPage = ({ state }: UseDetailPageProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })
  const [pageLoading, setPageLoading] = useState(false)   //表格 loading

  const [isModalVisible, setIsModalVisible] = useState(false);   //弹窗是否显示

  const [detailLoading, setDetailLoading] = useState(false)  //表格 loading

  const [detailList, setDetailList] = useState([])


  const getPage = () => {    //获取表格数据
    setPageLoading(true)
    dispatch(getUseDetail(params))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  const ListExport = () => {
    dispatch(getUseDetailExport(params))
      .then(unwrapResult)
      .then((res: any) => {
        console.log(res, 'res');
        const content = res
        const blob = new Blob([content])
        const fileName = '使用详情导出数据.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        console.log('失败')
      })
  }



  useEffect(() => {
    params.current && getPage()
  }, [params])

  useEffect(() => {   //缓存tab 栏
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  return (
    <div className={styles.containers}>
      <div className={styles.content}>
        {/* 查询区域 */}
        <div>
          <UseQuery
            submit={(obj) => {
              setParams({
                ...params,
                ...obj,
                current: 1
              })
            }}
            ListExport={() => ListExport()}
          />
        </div>

        {/* 表格区域 */}
        <div className={styles.tableWrap} style={{ height: 'calc(100% - 50px)' }}>
          <EditableList
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={UseColumns(
              (t: any) => {

                dispatch(getUseDetailFive({ tenantId: t.id }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    setDetailList(res)
                    setIsModalVisible(true)
                  })
              },
              params.size * (params.current - 1),
            )}
            onChangePage={(current: number, size?: number) => {
              setParams({
                ...params,
                current,
                size
              })

            }}
          />
        </div>
      </div>


      <Modal
        title="排列前五的高发疾病"
        visible={isModalVisible}
        width={800}
        style={{ height: 800 }}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => setIsModalVisible(false)}
      >
        <Table
          className={styles.table}
          scroll={{ y: 200 }}
          dataSource={detailList}
          pagination={false}
          loading={detailLoading}
          columns={[
            {
              title: '疾病名称',
              dataIndex: 'name',
              key: 'name',
              align: 'center',
              width: 100
            },
            {
              title: '次数',
              dataIndex: 'val',
              key: 'val',
              align: 'center',
              width: 100
            },
          ]}
        />
      </Modal>     

    </div>
  );
}

